import { brandConfig } from "../config/brandConfig";
import { Helmet } from "react-helmet-async";
export function GlobalSEO() {
  const {
    NDD,
    brandName,
    brandDescription,
    logo,
    sameAs,
    contactPoint: { contactType, email, telephone, availableLanguage },
    address: {
      addressLocality,
      addressCountry,
      addressRegion,
      postalCode,
      streetAddress,
    },
  } = brandConfig;

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${NDD}/#organization`,
    name: brandName,
    url: NDD,
    logo: logo,
    description: brandDescription,
    sameAs: sameAs,
    contactPoint: [
      {
        "@type": "ContactPoint",
        contactType: contactType,
        email: email,
        telephone: telephone,
        availableLanguage: availableLanguage,
      },
    ],
    address: {
      "@type": "PostalAddress",
      streetAddress: streetAddress,
      addressLocality: addressLocality,
      addressCountry: addressCountry,
      addressRegion: addressRegion,
      postalCode: postalCode,
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
    </Helmet>
  );
}
